var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignGroupExcluded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 402.32,
    height: 382.396,
    viewBox: "0 0 402.32 382.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8638",
    "data-name": "Caminho 8638",
    d: "M9.24,191.573c-18.4,34.088-4.9,66.377,2.646,84.438,15.547,37.246,67.68,84.963,192.675,93.346C365.547,380.063,389.96,244.2,385.395,185.685S373.883,50.318,241.8,7.633,161.482,113.227,59.862,156.725C41.8,164.444,18.458,174.508,9.24,191.573Z",
    transform: "translate(0 0.001)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Campaign_Group_Excluded",
    "data-name": "Campaign Group Excluded",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-0.002 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8628",
    "data-name": "Caminho 8628",
    d: "M9.24,197.306c-18.4,35.108-4.9,68.364,2.646,86.965,15.547,38.361,67.68,87.506,192.675,96.139,160.985,11.026,185.4-128.9,180.833-189.169S373.883,51.824,241.8,7.862,161.482,116.615,59.862,161.416C41.8,169.366,18.458,179.73,9.24,197.306Z",
    transform: "translate(0 0.001)",
    fill: "#ffe3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8629",
    "data-name": "Caminho 8629",
    d: "M17.17,129.464a10.607,10.607,0,0,0,8.821,6.439c15.1,1.489,36.883-4.918,59.41-33.223,25.173-31.657,52.772-64.306,25.736-61.748S39.465,69.128,23.245,95.977C13.266,112.439,14.656,123.433,17.17,129.464Z",
    transform: "translate(1.576 4.187)",
    fill: "#ffe3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8630",
    "data-name": "Caminho 8630",
    d: "M17.17,129.464a10.607,10.607,0,0,0,8.821,6.439c15.1,1.489,36.883-4.918,59.41-33.223,25.173-31.657,52.772-64.306,25.736-61.748S39.465,69.128,23.245,95.977C13.266,112.439,14.656,123.433,17.17,129.464Z",
    transform: "translate(1.576 4.187)",
    fill: "#fff",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7150",
    "data-name": "Grupo 7150",
    transform: "translate(0 11.072)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2201",
    "data-name": "Ret\\xE2ngulo 2201",
    width: 466.626,
    height: 424.307,
    transform: "translate(-55.54 -22.924)",
    fill: "#ffe3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8631",
    "data-name": "Caminho 8631",
    d: "M134.042,134.374V120.691h22.714V55.26h6.252v65.431h24.468v13.684h13.1V408.722H106.09V134.374Z",
    transform: "translate(-99.948 -17.252)",
    fill: "#e6a786"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2202",
    "data-name": "Ret\\xE2ngulo 2202",
    width: 13.099,
    height: 246.782,
    transform: "translate(6.142 117.122)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2203",
    "data-name": "Ret\\xE2ngulo 2203",
    width: 94.485,
    height: 208.994,
    transform: "translate(53.379 182.475)",
    fill: "#e6a786"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2204",
    "data-name": "Ret\\xE2ngulo 2204",
    width: 13.099,
    height: 208.994,
    transform: "translate(53.379 182.475)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2205",
    "data-name": "Ret\\xE2ngulo 2205",
    width: 13.562,
    height: 5.623,
    transform: "translate(121.125 191.385)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2206",
    "data-name": "Ret\\xE2ngulo 2206",
    width: 13.562,
    height: 5.623,
    transform: "translate(98.301 191.385)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2207",
    "data-name": "Ret\\xE2ngulo 2207",
    width: 13.562,
    height: 5.623,
    transform: "translate(121.125 211.872)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2208",
    "data-name": "Ret\\xE2ngulo 2208",
    width: 13.562,
    height: 5.623,
    transform: "translate(98.301 211.872)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2209",
    "data-name": "Ret\\xE2ngulo 2209",
    width: 13.551,
    height: 5.623,
    transform: "translate(75.476 211.872)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2210",
    "data-name": "Ret\\xE2ngulo 2210",
    width: 13.562,
    height: 5.623,
    transform: "translate(121.125 232.359)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2211",
    "data-name": "Ret\\xE2ngulo 2211",
    width: 13.551,
    height: 5.623,
    transform: "translate(75.476 232.359)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2212",
    "data-name": "Ret\\xE2ngulo 2212",
    width: 13.562,
    height: 5.623,
    transform: "translate(98.301 242.602)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2213",
    "data-name": "Ret\\xE2ngulo 2213",
    width: 13.562,
    height: 5.623,
    transform: "translate(121.125 252.846)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2214",
    "data-name": "Ret\\xE2ngulo 2214",
    width: 13.562,
    height: 5.623,
    transform: "translate(98.301 263.089)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2215",
    "data-name": "Ret\\xE2ngulo 2215",
    width: 13.562,
    height: 5.623,
    transform: "translate(121.125 273.333)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2216",
    "data-name": "Ret\\xE2ngulo 2216",
    width: 13.551,
    height: 5.623,
    transform: "translate(75.476 273.333)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2217",
    "data-name": "Ret\\xE2ngulo 2217",
    width: 13.562,
    height: 5.623,
    transform: "translate(121.125 292.265)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2218",
    "data-name": "Ret\\xE2ngulo 2218",
    width: 13.562,
    height: 5.623,
    transform: "translate(98.301 292.265)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2219",
    "data-name": "Ret\\xE2ngulo 2219",
    width: 13.562,
    height: 5.623,
    transform: "translate(121.125 312.752)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2220",
    "data-name": "Ret\\xE2ngulo 2220",
    width: 13.562,
    height: 5.623,
    transform: "translate(98.301 312.752)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2221",
    "data-name": "Ret\\xE2ngulo 2221",
    width: 13.551,
    height: 5.623,
    transform: "translate(75.476 312.752)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2222",
    "data-name": "Ret\\xE2ngulo 2222",
    width: 13.562,
    height: 5.623,
    transform: "translate(121.125 333.239)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2223",
    "data-name": "Ret\\xE2ngulo 2223",
    width: 13.551,
    height: 5.623,
    transform: "translate(75.476 333.239)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2224",
    "data-name": "Ret\\xE2ngulo 2224",
    width: 13.562,
    height: 5.623,
    transform: "translate(98.301 343.483)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2225",
    "data-name": "Ret\\xE2ngulo 2225",
    width: 13.551,
    height: 5.623,
    transform: "translate(75.476 343.483)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2226",
    "data-name": "Ret\\xE2ngulo 2226",
    width: 13.562,
    height: 5.623,
    transform: "translate(121.125 353.726)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2227",
    "data-name": "Ret\\xE2ngulo 2227",
    width: 13.562,
    height: 5.623,
    transform: "translate(98.301 363.97)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2228",
    "data-name": "Ret\\xE2ngulo 2228",
    width: 13.562,
    height: 5.623,
    transform: "translate(121.125 374.214)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2229",
    "data-name": "Ret\\xE2ngulo 2229",
    width: 13.551,
    height: 5.623,
    transform: "translate(75.476 374.214)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2230",
    "data-name": "Ret\\xE2ngulo 2230",
    width: 94.485,
    height: 208.994,
    transform: "translate(279.442 182.475)",
    fill: "#e6a786"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2231",
    "data-name": "Ret\\xE2ngulo 2231",
    width: 13.099,
    height: 208.994,
    transform: "translate(279.442 182.475)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2232",
    "data-name": "Ret\\xE2ngulo 2232",
    width: 126.77,
    height: 308.397,
    transform: "translate(145.229 83.072)",
    fill: "#e6a786"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2233",
    "data-name": "Ret\\xE2ngulo 2233",
    width: 13.099,
    height: 308.397,
    transform: "translate(145.229 83.072)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2234",
    "data-name": "Ret\\xE2ngulo 2234",
    width: 19.792,
    height: 8.215,
    transform: "translate(238.854 97.837)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2235",
    "data-name": "Ret\\xE2ngulo 2235",
    width: 19.803,
    height: 8.215,
    transform: "translate(205.521 97.837)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2236",
    "data-name": "Ret\\xE2ngulo 2236",
    width: 19.792,
    height: 8.215,
    transform: "translate(238.854 127.762)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2237",
    "data-name": "Ret\\xE2ngulo 2237",
    width: 19.803,
    height: 8.215,
    transform: "translate(205.521 127.762)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2238",
    "data-name": "Ret\\xE2ngulo 2238",
    width: 19.792,
    height: 8.215,
    transform: "translate(172.188 127.762)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2239",
    "data-name": "Ret\\xE2ngulo 2239",
    width: 19.792,
    height: 8.215,
    transform: "translate(238.854 157.677)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2240",
    "data-name": "Ret\\xE2ngulo 2240",
    width: 19.792,
    height: 8.215,
    transform: "translate(172.188 157.677)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2241",
    "data-name": "Ret\\xE2ngulo 2241",
    width: 19.803,
    height: 8.215,
    transform: "translate(205.521 172.64)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2242",
    "data-name": "Ret\\xE2ngulo 2242",
    width: 19.792,
    height: 8.215,
    transform: "translate(238.854 187.592)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2243",
    "data-name": "Ret\\xE2ngulo 2243",
    width: 19.803,
    height: 8.215,
    transform: "translate(205.521 202.555)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2244",
    "data-name": "Ret\\xE2ngulo 2244",
    width: 19.792,
    height: 8.215,
    transform: "translate(238.854 217.517)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2245",
    "data-name": "Ret\\xE2ngulo 2245",
    width: 19.792,
    height: 8.215,
    transform: "translate(172.188 217.517)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2246",
    "data-name": "Ret\\xE2ngulo 2246",
    width: 19.792,
    height: 8.215,
    transform: "translate(238.854 245.161)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2247",
    "data-name": "Ret\\xE2ngulo 2247",
    width: 19.803,
    height: 8.215,
    transform: "translate(205.521 245.161)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2248",
    "data-name": "Ret\\xE2ngulo 2248",
    width: 19.792,
    height: 8.215,
    transform: "translate(238.854 275.075)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2249",
    "data-name": "Ret\\xE2ngulo 2249",
    width: 19.803,
    height: 8.215,
    transform: "translate(205.521 275.075)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2250",
    "data-name": "Ret\\xE2ngulo 2250",
    width: 19.792,
    height: 8.215,
    transform: "translate(172.188 275.075)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2251",
    "data-name": "Ret\\xE2ngulo 2251",
    width: 19.792,
    height: 8.215,
    transform: "translate(238.854 305.001)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2252",
    "data-name": "Ret\\xE2ngulo 2252",
    width: 19.792,
    height: 8.215,
    transform: "translate(172.188 305.001)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2253",
    "data-name": "Ret\\xE2ngulo 2253",
    width: 19.803,
    height: 8.215,
    transform: "translate(205.521 319.953)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2254",
    "data-name": "Ret\\xE2ngulo 2254",
    width: 19.792,
    height: 8.215,
    transform: "translate(172.188 319.953)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2255",
    "data-name": "Ret\\xE2ngulo 2255",
    width: 19.792,
    height: 8.215,
    transform: "translate(238.854 334.915)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2256",
    "data-name": "Ret\\xE2ngulo 2256",
    width: 19.803,
    height: 8.215,
    transform: "translate(205.521 349.878)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2257",
    "data-name": "Ret\\xE2ngulo 2257",
    width: 19.792,
    height: 8.215,
    transform: "translate(238.854 364.83)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2258",
    "data-name": "Ret\\xE2ngulo 2258",
    width: 19.792,
    height: 8.215,
    transform: "translate(172.188 364.83)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2259",
    "data-name": "Ret\\xE2ngulo 2259",
    width: 124.245,
    height: 285.407,
    transform: "translate(344.542 106.062)",
    fill: "#e6a786"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2260",
    "data-name": "Ret\\xE2ngulo 2260",
    width: 12.835,
    height: 285.407,
    transform: "translate(344.542 106.062)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2261",
    "data-name": "Ret\\xE2ngulo 2261",
    width: 19.406,
    height: 7.608,
    transform: "translate(436.293 119.724)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2262",
    "data-name": "Ret\\xE2ngulo 2262",
    width: 19.406,
    height: 7.608,
    transform: "translate(403.621 119.724)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2263",
    "data-name": "Ret\\xE2ngulo 2263",
    width: 19.406,
    height: 7.608,
    transform: "translate(436.293 147.411)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2264",
    "data-name": "Ret\\xE2ngulo 2264",
    width: 19.406,
    height: 7.608,
    transform: "translate(403.621 147.411)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2265",
    "data-name": "Ret\\xE2ngulo 2265",
    width: 19.406,
    height: 7.608,
    transform: "translate(370.95 147.411)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2266",
    "data-name": "Ret\\xE2ngulo 2266",
    width: 19.406,
    height: 7.608,
    transform: "translate(436.293 175.099)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2267",
    "data-name": "Ret\\xE2ngulo 2267",
    width: 19.406,
    height: 7.608,
    transform: "translate(370.95 175.099)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2268",
    "data-name": "Ret\\xE2ngulo 2268",
    width: 19.406,
    height: 7.608,
    transform: "translate(403.621 188.948)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2269",
    "data-name": "Ret\\xE2ngulo 2269",
    width: 19.406,
    height: 7.608,
    transform: "translate(436.293 202.797)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2270",
    "data-name": "Ret\\xE2ngulo 2270",
    width: 19.406,
    height: 7.608,
    transform: "translate(403.621 216.635)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2271",
    "data-name": "Ret\\xE2ngulo 2271",
    width: 19.406,
    height: 7.608,
    transform: "translate(436.293 230.484)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2272",
    "data-name": "Ret\\xE2ngulo 2272",
    width: 19.406,
    height: 7.608,
    transform: "translate(370.95 230.484)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2273",
    "data-name": "Ret\\xE2ngulo 2273",
    width: 19.406,
    height: 7.608,
    transform: "translate(436.293 256.066)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2274",
    "data-name": "Ret\\xE2ngulo 2274",
    width: 19.406,
    height: 7.608,
    transform: "translate(403.621 256.066)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2275",
    "data-name": "Ret\\xE2ngulo 2275",
    width: 19.406,
    height: 7.608,
    transform: "translate(436.293 283.753)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2276",
    "data-name": "Ret\\xE2ngulo 2276",
    width: 19.406,
    height: 7.608,
    transform: "translate(403.621 283.753)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2277",
    "data-name": "Ret\\xE2ngulo 2277",
    width: 19.406,
    height: 7.608,
    transform: "translate(370.95 283.753)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2278",
    "data-name": "Ret\\xE2ngulo 2278",
    width: 19.406,
    height: 7.608,
    transform: "translate(436.293 311.44)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2279",
    "data-name": "Ret\\xE2ngulo 2279",
    width: 19.406,
    height: 7.608,
    transform: "translate(370.95 311.44)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2280",
    "data-name": "Ret\\xE2ngulo 2280",
    width: 19.406,
    height: 7.608,
    transform: "translate(403.621 325.289)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2281",
    "data-name": "Ret\\xE2ngulo 2281",
    width: 19.406,
    height: 7.608,
    transform: "translate(370.95 325.289)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2282",
    "data-name": "Ret\\xE2ngulo 2282",
    width: 19.406,
    height: 7.608,
    transform: "translate(436.293 339.128)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2283",
    "data-name": "Ret\\xE2ngulo 2283",
    width: 19.406,
    height: 7.608,
    transform: "translate(403.621 352.977)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2284",
    "data-name": "Ret\\xE2ngulo 2284",
    width: 19.406,
    height: 7.608,
    transform: "translate(436.293 366.815)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2285",
    "data-name": "Ret\\xE2ngulo 2285",
    width: 19.406,
    height: 7.608,
    transform: "translate(370.95 366.815)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2286",
    "data-name": "Ret\\xE2ngulo 2286",
    width: 80.019,
    height: 194.671,
    transform: "translate(-56.984 196.799)",
    fill: "#e6a786"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2287",
    "data-name": "Ret\\xE2ngulo 2287",
    width: 12.493,
    height: 5.182,
    transform: "translate(2.106 206.127)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2288",
    "data-name": "Ret\\xE2ngulo 2288",
    width: 12.493,
    height: 5.182,
    transform: "translate(-18.932 206.127)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2289",
    "data-name": "Ret\\xE2ngulo 2289",
    width: 12.493,
    height: 5.182,
    transform: "translate(2.106 225.004)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2290",
    "data-name": "Ret\\xE2ngulo 2290",
    width: 12.493,
    height: 5.182,
    transform: "translate(-18.932 225.004)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2291",
    "data-name": "Ret\\xE2ngulo 2291",
    width: 12.493,
    height: 5.182,
    transform: "translate(-39.97 225.004)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2292",
    "data-name": "Ret\\xE2ngulo 2292",
    width: 12.493,
    height: 5.182,
    transform: "translate(2.106 243.892)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2293",
    "data-name": "Ret\\xE2ngulo 2293",
    width: 12.493,
    height: 5.182,
    transform: "translate(-39.97 243.892)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2294",
    "data-name": "Ret\\xE2ngulo 2294",
    width: 12.493,
    height: 5.182,
    transform: "translate(-18.932 253.331)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2295",
    "data-name": "Ret\\xE2ngulo 2295",
    width: 12.493,
    height: 5.182,
    transform: "translate(2.106 262.781)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2296",
    "data-name": "Ret\\xE2ngulo 2296",
    width: 12.493,
    height: 5.182,
    transform: "translate(-18.932 272.219)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2297",
    "data-name": "Ret\\xE2ngulo 2297",
    width: 12.493,
    height: 5.182,
    transform: "translate(2.106 281.658)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2298",
    "data-name": "Ret\\xE2ngulo 2298",
    width: 12.493,
    height: 5.182,
    transform: "translate(-39.97 281.658)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2299",
    "data-name": "Ret\\xE2ngulo 2299",
    width: 12.493,
    height: 5.182,
    transform: "translate(2.106 299.113)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2300",
    "data-name": "Ret\\xE2ngulo 2300",
    width: 12.493,
    height: 5.182,
    transform: "translate(-18.932 299.113)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2301",
    "data-name": "Ret\\xE2ngulo 2301",
    width: 12.493,
    height: 5.182,
    transform: "translate(2.106 318.001)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2302",
    "data-name": "Ret\\xE2ngulo 2302",
    width: 12.493,
    height: 5.182,
    transform: "translate(-18.932 318.001)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2303",
    "data-name": "Ret\\xE2ngulo 2303",
    width: 12.493,
    height: 5.182,
    transform: "translate(-39.97 318.001)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2304",
    "data-name": "Ret\\xE2ngulo 2304",
    width: 12.493,
    height: 5.182,
    transform: "translate(2.106 336.889)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2305",
    "data-name": "Ret\\xE2ngulo 2305",
    width: 12.493,
    height: 5.182,
    transform: "translate(-39.97 336.889)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2306",
    "data-name": "Ret\\xE2ngulo 2306",
    width: 12.493,
    height: 5.182,
    transform: "translate(-18.932 346.328)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2307",
    "data-name": "Ret\\xE2ngulo 2307",
    width: 12.493,
    height: 5.182,
    transform: "translate(-39.97 346.328)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2308",
    "data-name": "Ret\\xE2ngulo 2308",
    width: 12.493,
    height: 5.182,
    transform: "translate(2.106 355.766)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2309",
    "data-name": "Ret\\xE2ngulo 2309",
    width: 12.493,
    height: 5.182,
    transform: "translate(-18.932 365.216)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2310",
    "data-name": "Ret\\xE2ngulo 2310",
    width: 12.493,
    height: 5.182,
    transform: "translate(2.106 374.655)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2311",
    "data-name": "Ret\\xE2ngulo 2311",
    width: 12.493,
    height: 5.182,
    transform: "translate(-39.97 374.655)",
    fill: "#a67566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2312",
    "data-name": "Ret\\xE2ngulo 2312",
    width: 339.117,
    height: 386.652,
    transform: "translate(-107.132 -7.554)",
    fill: "#fff",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2313",
    "data-name": "Ret\\xE2ngulo 2313",
    width: 7.421,
    height: 396.068,
    transform: "translate(228.28 -11.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8632",
    "data-name": "Caminho 8632",
    d: "M111.7,393.2H85.38L226.463,17.96h26.32Z",
    transform: "translate(-102.074 -21.081)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8633",
    "data-name": "Caminho 8633",
    d: "M68.326,393.2H55.16L196.254,17.96h13.166Z",
    transform: "translate(-105.176 -21.081)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8634",
    "data-name": "Caminho 8634",
    d: "M210.825,389.45H197.67L318.63,54.49V81.483Z",
    transform: "translate(-90.548 -17.332)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2314",
    "data-name": "Ret\\xE2ngulo 2314",
    width: 346.538,
    height: 10.233,
    transform: "translate(-110.837 374.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2315",
    "data-name": "Ret\\xE2ngulo 2315",
    width: 7.421,
    height: 392.066,
    transform: "translate(115.237 -9.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2316",
    "data-name": "Ret\\xE2ngulo 2316",
    width: 331.619,
    height: 3.12,
    transform: "translate(-103.383 372.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2317",
    "data-name": "Ret\\xE2ngulo 2317",
    width: 346.538,
    height: 8.843,
    transform: "translate(-110.837 -11.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2318",
    "data-name": "Ret\\xE2ngulo 2318",
    width: 331.762,
    height: 3.12,
    transform: "translate(-103.449 -3.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2319",
    "data-name": "Ret\\xE2ngulo 2319",
    width: 339.117,
    height: 386.652,
    transform: "translate(233.771 -15.195)",
    fill: "#fff",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2320",
    "data-name": "Ret\\xE2ngulo 2320",
    width: 7.421,
    height: 396.068,
    transform: "translate(228.313 -11.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2321",
    "data-name": "Ret\\xE2ngulo 2321",
    width: 7.421,
    height: 396.068,
    transform: "translate(567.43 -11.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8635",
    "data-name": "Caminho 8635",
    d: "M365.839,393.2H339.53L480.613,17.96h26.32Z",
    transform: "translate(-75.988 -21.081)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8636",
    "data-name": "Caminho 8636",
    d: "M322.476,393.2H309.31L450.4,17.96h13.155Z",
    transform: "translate(-79.09 -21.081)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8637",
    "data-name": "Caminho 8637",
    d: "M518.4,389.45H505.25L626.21,54.49V81.483Z",
    transform: "translate(-58.978 -17.332)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2322",
    "data-name": "Ret\\xE2ngulo 2322",
    width: 7.421,
    height: 392.066,
    transform: "translate(341.355 -9.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2323",
    "data-name": "Ret\\xE2ngulo 2323",
    width: 346.538,
    height: 10.233,
    transform: "translate(228.313 374.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2324",
    "data-name": "Ret\\xE2ngulo 2324",
    width: 7.421,
    height: 392.066,
    transform: "translate(454.387 -9.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2325",
    "data-name": "Ret\\xE2ngulo 2325",
    width: 331.619,
    height: 3.12,
    transform: "translate(235.767 372.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2326",
    "data-name": "Ret\\xE2ngulo 2326",
    width: 346.538,
    height: 8.843,
    transform: "translate(228.313 -11.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2327",
    "data-name": "Ret\\xE2ngulo 2327",
    width: 331.762,
    height: 3.12,
    transform: "translate(235.701 -3.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2328",
    "data-name": "Ret\\xE2ngulo 2328",
    width: 697.872,
    height: 4.422,
    transform: "translate(-110.837 57.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2329",
    "data-name": "Ret\\xE2ngulo 2329",
    width: 697.872,
    height: 4.422,
    transform: "translate(-110.837 175.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2330",
    "data-name": "Ret\\xE2ngulo 2330",
    width: 697.872,
    height: 4.422,
    transform: "translate(-110.837 293.71)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8639",
    "data-name": "Caminho 8639",
    d: "M384.978,346.931H.9a.706.706,0,1,1,0-1.411H384.978a.706.706,0,0,1,0,1.411Z",
    transform: "translate(0.02 35.465)",
    fill: "#bfbdb1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2331",
    "data-name": "Ret\\xE2ngulo 2331",
    width: 224.828,
    height: 126.142,
    transform: "translate(128.146 368.212) rotate(-89.89)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8640",
    "data-name": "Caminho 8640",
    d: "M233.9,122.49l-72.929.419v9.472l36.938.066,26.32.143a16.065,16.065,0,0,1,16.032,16.1l-.342,183.149A16.076,16.076,0,0,1,223.83,347.87l-63.269.121v19.847l72.929.684a16.054,16.054,0,0,0,16.087-16.032l.408-213.912A16.054,16.054,0,0,0,233.9,122.49Z",
    transform: "translate(16.48 12.573)",
    fill: "#4a5396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8641",
    "data-name": "Caminho 8641",
    d: "M234.526,122.518l-.9-.088H120.37a10.42,10.42,0,0,0-10.42,10.409V358.086a10.4,10.4,0,0,0,10.4,10.4H233.6a16.065,16.065,0,0,0,14.93-16.076V138.5a16.077,16.077,0,0,0-14-15.977ZM119.609,233.6V142.906a10.4,10.4,0,0,1,10.4-10.4h98.477a10.442,10.442,0,0,1,10.42,10.4V337.357a10.42,10.42,0,0,1-10.42,10.409H130.018a10.409,10.409,0,0,1-10.4-10.409Z",
    transform: "translate(11.285 12.567)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8642",
    "data-name": "Caminho 8642",
    d: "M187.65,341.478l-26.728-.055a4.852,4.852,0,0,1-4.852-4.863h0a4.852,4.852,0,0,1,4.863-4.841h26.739a4.841,4.841,0,0,1,4.841,4.863h0a4.852,4.852,0,0,1-4.863,4.9Z",
    transform: "translate(16.019 34.048)",
    fill: "#4a5396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8643",
    "data-name": "Caminho 8643",
    d: "M319.741,330.371H317.15v-1.036H318.7V327.78h1.036Z",
    transform: "translate(-78.285 21.791)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8644",
    "data-name": "Caminho 8644",
    d: "M221.145,319.477h-4.311V318.44h4.311Zm-8.612,0h-4.322V318.44h4.311Zm-8.612,0h-4.3V318.44h4.3Zm-8.612,0h-4.3V318.44h4.3Zm-8.612,0h-4.3V318.44h4.3Zm-8.612,0h-4.3V318.44h4.3Zm-8.6,0h-4.278V318.44h4.311Zm-8.612,0h-4.311V318.44h4.311Zm-8.612,0h-4.3V318.44h4.3Zm-8.612,0h-4.3V318.44h4.3Zm-8.612,0h-4.3V318.44h4.3Z",
    transform: "translate(13.419 32.685)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8645",
    "data-name": "Caminho 8645",
    d: "M227.6,330.371H225.01V327.78h1.036v1.555H227.6Z",
    transform: "translate(-87.742 21.791)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8646",
    "data-name": "Caminho 8646",
    d: "M125.526,315.878H124.49v-4.543h1.036Zm0-9.075H124.49v-4.543h1.036Zm0-9.086H124.49v-4.532h1.036Zm0-9.075H124.49V284.1h1.036Z",
    transform: "translate(12.778 29.161)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8647",
    "data-name": "Caminho 8647",
    d: "M226.046,290.97H225.01v-2.58H227.6v1.036h-1.555Z",
    transform: "translate(-87.742 17.748)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8648",
    "data-name": "Caminho 8648",
    d: "M221.145,278.676h-4.311V277.64h4.311Zm-8.612,0h-4.322V277.64h4.311Zm-8.612,0h-4.3V277.64h4.3Zm-8.612,0h-4.3V277.64h4.3Zm-8.612,0h-4.3V277.64h4.3Zm-8.612,0h-4.3V277.64h4.3Zm-8.6,0h-4.278V277.64h4.311Zm-8.612,0h-4.311V277.64h4.311Zm-8.612,0h-4.3V277.64h4.3Zm-8.612,0h-4.3V277.64h4.3Zm-8.612,0h-4.3V277.64h4.3Z",
    transform: "translate(13.419 28.498)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8649",
    "data-name": "Caminho 8649",
    d: "M319.741,290.97H318.7v-1.544H317.15V288.39h2.591Z",
    transform: "translate(-78.285 17.748)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8650",
    "data-name": "Caminho 8650",
    d: "M219.1,315.878H218v-4.543h1.1Zm0-9.075H218v-4.543h1.1Zm0-9.086H218v-4.532h1.1Zm0-9.075H218V284.1h1.1Z",
    transform: "translate(22.376 29.161)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2332",
    "data-name": "Ret\\xE2ngulo 2332",
    width: 5.745,
    height: 29.187,
    transform: "translate(187.008 313.713)",
    fill: "#e0dcd1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2333",
    "data-name": "Ret\\xE2ngulo 2333",
    width: 5.745,
    height: 29.198,
    transform: "translate(204.463 325.434) rotate(90)",
    fill: "#e0dcd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8651",
    "data-name": "Caminho 8651",
    d: "M319.741,284.381H317.15v-1.036H318.7V281.79h1.036Z",
    transform: "translate(-78.285 17.07)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8652",
    "data-name": "Caminho 8652",
    d: "M221.145,273.487h-4.311V272.45h4.311Zm-8.612,0h-4.322V272.45h4.311Zm-8.612,0h-4.3V272.45h4.3Zm-8.612,0h-4.3V272.45h4.3Zm-8.612,0h-4.3V272.45h4.3Zm-8.612,0h-4.3V272.45h4.3Zm-8.6,0h-4.278V272.45h4.311Zm-8.612,0h-4.311V272.45h4.311Zm-8.612,0h-4.3V272.45h4.3Zm-8.612,0h-4.3V272.45h4.3Zm-8.612,0h-4.3V272.45h4.3Z",
    transform: "translate(13.419 27.965)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8653",
    "data-name": "Caminho 8653",
    d: "M227.6,284.381H225.01V281.79h1.036v1.555H227.6Z",
    transform: "translate(-87.742 17.07)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8654",
    "data-name": "Caminho 8654",
    d: "M125.526,269.887H124.49v-4.543h1.036Zm0-9.075H124.49V256.27h1.036Zm0-9.086H124.49v-4.532h1.036Zm0-9.075H124.49V238.12h1.036Z",
    transform: "translate(12.778 24.441)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8655",
    "data-name": "Caminho 8655",
    d: "M226.046,244.991H225.01V242.4H227.6v1.036h-1.555Z",
    transform: "translate(-87.742 13.027)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8656",
    "data-name": "Caminho 8656",
    d: "M221.145,232.686h-4.311V231.65h4.311Zm-8.612,0h-4.322V231.65h4.311Zm-8.612,0h-4.3V231.65h4.3Zm-8.612,0h-4.3V231.65h4.3Zm-8.612,0h-4.3V231.65h4.3Zm-8.612,0h-4.3V231.65h4.3Zm-8.6,0h-4.278V231.65h4.311Zm-8.612,0h-4.311V231.65h4.311Zm-8.612,0h-4.3V231.65h4.3Zm-8.612,0h-4.3V231.65h4.3Zm-8.612,0h-4.3V231.65h4.3Z",
    transform: "translate(13.419 23.777)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8657",
    "data-name": "Caminho 8657",
    d: "M319.741,244.991H318.7v-1.555H317.15V242.4h2.591Z",
    transform: "translate(-78.285 13.027)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8658",
    "data-name": "Caminho 8658",
    d: "M219.1,269.887H218v-4.543h1.1Zm0-9.075H218V256.27h1.1Zm0-9.086H218v-4.532h1.1Zm0-9.075H218V238.12h1.1Z",
    transform: "translate(22.376 24.441)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2334",
    "data-name": "Ret\\xE2ngulo 2334",
    width: 5.745,
    height: 29.198,
    transform: "translate(187.008 263.002)",
    fill: "#e0dcd1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2335",
    "data-name": "Ret\\xE2ngulo 2335",
    width: 5.745,
    height: 29.198,
    transform: "translate(204.463 274.723) rotate(90)",
    fill: "#e0dcd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8659",
    "data-name": "Caminho 8659",
    d: "M319.741,237.651H317.15v-1.036H318.7V235.06h1.036Z",
    transform: "translate(-78.285 12.274)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8660",
    "data-name": "Caminho 8660",
    d: "M221.145,226.757h-4.311V225.72h4.311Zm-8.612,0h-4.322V225.72h4.311Zm-8.612,0h-4.3V225.72h4.3Zm-8.612,0h-4.3V225.72h4.3Zm-8.612,0h-4.3V225.72h4.3Zm-8.612,0h-4.3V225.72h4.3Zm-8.6,0h-4.278V225.72h4.311Zm-8.612,0h-4.311V225.72h4.311Zm-8.612,0h-4.3V225.72h4.3Zm-8.612,0h-4.3V225.72h4.3Zm-8.612,0h-4.3V225.72h4.3Z",
    transform: "translate(13.419 23.169)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8661",
    "data-name": "Caminho 8661",
    d: "M227.6,237.651H225.01V235.06h1.036v1.555H227.6Z",
    transform: "translate(-87.742 12.274)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8662",
    "data-name": "Caminho 8662",
    d: "M125.526,223.157H124.49v-4.543h1.036Zm0-9.075H124.49v-4.543h1.036Zm0-9.086H124.49v-4.532h1.036Zm0-9.075H124.49V191.39h1.036Z",
    transform: "translate(12.778 19.645)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8663",
    "data-name": "Caminho 8663",
    d: "M226.046,198.261H225.01V195.67H227.6v1.036h-1.555Z",
    transform: "translate(-87.742 8.231)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8664",
    "data-name": "Caminho 8664",
    d: "M221.145,185.956h-4.311V184.92h4.311Zm-8.612,0h-4.322V184.92h4.311Zm-8.612,0h-4.3V184.92h4.3Zm-8.612,0h-4.3V184.92h4.3Zm-8.612,0h-4.3V184.92h4.3Zm-8.612,0h-4.3V184.92h4.3Zm-8.6,0h-4.278V184.92h4.311Zm-8.612,0h-4.311V184.92h4.311Zm-8.612,0h-4.3V184.92h4.3Zm-8.612,0h-4.3V184.92h4.3Zm-8.612,0h-4.3V184.92h4.3Z",
    transform: "translate(13.419 18.981)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8665",
    "data-name": "Caminho 8665",
    d: "M319.741,198.261H318.7v-1.555H317.15V195.67h2.591Z",
    transform: "translate(-78.285 8.231)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8666",
    "data-name": "Caminho 8666",
    d: "M219.1,223.157H218v-4.543h1.1Zm0-9.075H218v-4.543h1.1Zm0-9.075H218v-4.543h1.1Zm0-9.086H218V191.39h1.1Z",
    transform: "translate(22.376 19.645)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2336",
    "data-name": "Ret\\xE2ngulo 2336",
    width: 5.745,
    height: 29.198,
    transform: "translate(187.008 211.476)",
    fill: "#e0dcd1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2337",
    "data-name": "Ret\\xE2ngulo 2337",
    width: 5.745,
    height: 29.198,
    transform: "translate(204.474 223.197) rotate(90)",
    fill: "#e0dcd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8667",
    "data-name": "Caminho 8667",
    d: "M145.8,188.664h0l-.265-.121-2.36-1.1a2.04,2.04,0,0,0-1.1-.265l-15.58.948-6.88.408-2.437.154-4.94.3c-.728-.9-1.489-1.852-2.293-2.834v41.581l7.167-.474,2.5-.176,6.88-.452,4.565-.309a1.985,1.985,0,0,0,2.867,1.169.287.287,0,0,0,.154-.232,1.709,1.709,0,0,0,1.1.684,1.559,1.559,0,0,0,1.191-.816h0a2.437,2.437,0,0,0,2.293,1.334c.893-.154,1.1-.871,1.1-1.687a4.82,4.82,0,0,0,.75.75c1.1.849,2.205-.077,2.58-.97a.32.32,0,0,0-.066-.375.3.3,0,0,0,0-.1,1.752,1.752,0,0,0-.165-.5l2.205-.143V221.49l1.775-30.8a2.029,2.029,0,0,0-1.048-2.029Z",
    transform: "translate(11.284 19.107)",
    fill: "#292340",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2338",
    "data-name": "Ret\\xE2ngulo 2338",
    width: 109.558,
    height: 26.673,
    transform: "translate(135.349 161.879)",
    fill: "#d86e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8668",
    "data-name": "Caminho 8668",
    d: "M332.828,180.423l-24.842-8.843-21.788,7.4L246.5,165.14l-23.233,7.454v11.048l109.558-.033Z",
    transform: "translate(-87.921 5.097)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8669",
    "data-name": "Caminho 8669",
    d: "M220.784,149H196.361a1.7,1.7,0,1,0,0,3.385h24.424a1.7,1.7,0,0,0,0-3.385Z",
    transform: "translate(19.966 15.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8670",
    "data-name": "Caminho 8670",
    d: "M196.786,150.84a.276.276,0,1,0,.276.276A.276.276,0,0,0,196.786,150.84Z",
    transform: "translate(20.17 15.483)",
    fill: "#d86e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8671",
    "data-name": "Caminho 8671",
    d: "M199.116,150.84a.276.276,0,1,0,.276.276A.276.276,0,0,0,199.116,150.84Z",
    transform: "translate(20.409 15.483)",
    fill: "#d86e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8672",
    "data-name": "Caminho 8672",
    d: "M201.446,150.84a.276.276,0,1,0,.276.276A.276.276,0,0,0,201.446,150.84Z",
    transform: "translate(20.648 15.483)",
    fill: "#d86e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8673",
    "data-name": "Caminho 8673",
    d: "M217.7,149.7a.629.629,0,0,0-.629.629.617.617,0,0,0,.629.628.628.628,0,0,0,.629-.628A.639.639,0,0,0,217.7,149.7Zm0,1a.375.375,0,1,1,.364-.375.375.375,0,0,1-.364.375Z",
    transform: "translate(22.28 15.366)",
    fill: "#d86e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8674",
    "data-name": "Caminho 8674",
    d: "M318.41,161.407l.551.562.187-.187-.551-.562Z",
    transform: "translate(-78.156 4.695)",
    fill: "#d86e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8675",
    "data-name": "Caminho 8675",
    d: "M189.082,156.561a4.091,4.091,0,1,1-4.091-4.091,4.091,4.091,0,0,1,4.091,4.091Z",
    transform: "translate(18.568 15.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2339",
    "data-name": "Ret\\xE2ngulo 2339",
    width: 1.003,
    height: 1.003,
    transform: "matrix(1, -0.003, 0.003, 1, 185.989, 180.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2340",
    "data-name": "Ret\\xE2ngulo 2340",
    width: 1.003,
    height: 1.003,
    transform: "matrix(1, -0.003, 0.003, 1, 147.231, 180.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2341",
    "data-name": "Ret\\xE2ngulo 2341",
    width: 1.003,
    height: 1.003,
    transform: "matrix(1, -0.003, 0.003, 1, 185.963, 166.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2342",
    "data-name": "Ret\\xE2ngulo 2342",
    width: 1.003,
    height: 1.003,
    transform: "translate(166.583 166.857) rotate(-0.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2343",
    "data-name": "Ret\\xE2ngulo 2343",
    width: 1.003,
    height: 1.003,
    transform: "translate(166.585 180.177) rotate(-0.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2344",
    "data-name": "Ret\\xE2ngulo 2344",
    width: 1.003,
    height: 1.003,
    transform: "translate(147.216 173.413) rotate(-0.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2345",
    "data-name": "Ret\\xE2ngulo 2345",
    width: 1.003,
    height: 1.003,
    transform: "translate(185.962 173.3) rotate(-0.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2346",
    "data-name": "Ret\\xE2ngulo 2346",
    width: 1.003,
    height: 1.003,
    transform: "translate(147.188 166.863) rotate(-0.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8676",
    "data-name": "Caminho 8676",
    d: "M143.905,155.476H141.7V154.44h5.646v1.1H145.14v5.612h-1.235Z",
    transform: "translate(14.544 15.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8677",
    "data-name": "Caminho 8677",
    d: "M151.9,158.767h-3.992a1.544,1.544,0,0,0,1.654,1.213,1.863,1.863,0,0,0,1.378-.551l.64.728a2.867,2.867,0,0,1-4.863-1.764,2.525,2.525,0,0,1,2.624-2.6,2.47,2.47,0,0,1,2.569,2.613C151.914,158.514,151.9,158.657,151.9,158.767Zm-4-.783h2.878a1.367,1.367,0,0,0-1.433-1.235A1.4,1.4,0,0,0,147.9,157.984Z",
    transform: "translate(15.059 15.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8678",
    "data-name": "Caminho 8678",
    d: "M155.645,160.914l-1.312-1.764-1.3,1.764H151.72l1.963-2.591-1.9-2.492h1.345l1.246,1.654,1.246-1.665h1.29l-1.9,2.481,2,2.591Z",
    transform: "translate(15.573 15.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8679",
    "data-name": "Caminho 8679",
    d: "M160.4,160.72a1.852,1.852,0,0,1-1.1.353,1.577,1.577,0,0,1-1.764-1.709v-2.448H156.7v-.948h.827V154.81h1.191v1.169h1.367v.948h-1.356v2.415c0,.5.254.761.706.761a1.1,1.1,0,0,0,.673-.21Z",
    transform: "translate(16.084 15.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8680",
    "data-name": "Caminho 8680",
    d: "M169.371,164.071H168.8a.187.187,0,1,1,0-.375h.243v-.2a.193.193,0,0,1,.386,0Z",
    transform: "translate(17.306 16.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8681",
    "data-name": "Caminho 8681",
    d: "M170.673,164.036h-.761a.187.187,0,1,1,0-.375h.761a.187.187,0,1,1,0,.375Zm-2.282,0h-.761a.187.187,0,1,1,0-.375h.761a.187.187,0,1,1,0,.375Zm-2.282,0h-.761a.187.187,0,0,1-.187-.187.2.2,0,0,1,.187-.187h.761a.187.187,0,0,1,0,.375Zm-2.282,0h-.761a.193.193,0,0,1,0-.386h.761a.2.2,0,0,1,.2.187.21.21,0,0,1-.2.2Zm-2.282,0h-.761a.193.193,0,0,1,0-.386h.761a.193.193,0,1,1,0,.386Zm-2.282,0H158.5a.193.193,0,0,1,0-.386h.761a.193.193,0,1,1,0,.386Zm-2.26,0h-.761a.193.193,0,1,1,0-.386H157a.193.193,0,0,1,0,.386Zm-2.282,0h-.761a.193.193,0,1,1,0-.386h.761a.193.193,0,0,1-.011.386Zm-2.282,0h-.761a.193.193,0,1,1,0-.386h.761a.193.193,0,1,1-.011.386Zm-2.282,0h-.761a.193.193,0,0,1,0-.386h.761a.193.193,0,0,1-.011.386Zm-2.282,0h-.794a.193.193,0,0,1,0-.386h.761a.194.194,0,0,1,.022.386Zm-2.282,0h-.717a.193.193,0,0,1,0-.386h.761a.2.2,0,1,1-.055.386Zm-2.282,0h-.761a.193.193,0,0,1,0-.386h.761a.193.193,0,1,1-.011.386Zm-2.282,0h-.761a.2.2,0,0,1-.187-.187.187.187,0,0,1,.187-.187h.761a.188.188,0,1,1-.011.375Zm-2.282,0h-.761a.187.187,0,1,1,0-.375h.761a.187.187,0,0,1,.2.187.2.2,0,0,1-.209.187Zm-2.282,0H135.7a.187.187,0,1,1,0-.375h.761a.187.187,0,0,1,0,.375Z",
    transform: "translate(13.909 16.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8682",
    "data-name": "Caminho 8682",
    d: "M134.353,164.071h-.573V163.5a.187.187,0,0,1,.187-.187.2.2,0,0,1,.187.187v.2h.2a.187.187,0,1,1,0,.375Z",
    transform: "translate(13.731 16.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8683",
    "data-name": "Caminho 8683",
    d: "M134.018,163.275a.2.2,0,0,1-.2-.2v-.739a.193.193,0,0,1,.386,0v.739A.2.2,0,0,1,134.018,163.275Zm0-2.205a.2.2,0,0,1-.2-.187v-.739a.193.193,0,1,1,.386,0v.739a.2.2,0,0,1-.187.176Zm0-2.205a.2.2,0,0,1-.2-.187v-.739a.193.193,0,1,1,.386,0v.739a.2.2,0,0,1-.187.165Zm0-2.205a.2.2,0,0,1-.2-.187v-.739a.193.193,0,0,1,.386,0v.739a.2.2,0,0,1-.187.154Zm0-2.205a.187.187,0,0,1-.2-.187v-.739a.193.193,0,0,1,.386,0v.739a.187.187,0,0,1-.187.143Z",
    transform: "translate(13.735 15.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8684",
    "data-name": "Caminho 8684",
    d: "M134.018,152.382a.2.2,0,0,1-.2-.2v-.573h.573a.193.193,0,1,1,0,.386h-.187v.187A.2.2,0,0,1,134.018,152.382Z",
    transform: "translate(13.735 15.562)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8685",
    "data-name": "Caminho 8685",
    d: "M170.672,152.036h-.761a.193.193,0,1,1,0-.386h.761a.193.193,0,0,1,0,.386Zm-2.282,0h-.761a.193.193,0,1,1,0-.386h.761a.193.193,0,0,1,0,.386Zm-2.282,0h-.761a.193.193,0,0,1,0-.386h.761a.193.193,0,0,1,0,.386Zm-2.282,0h-.761a.193.193,0,0,1,0-.386h.761a.193.193,0,0,1,0,.386Zm-2.282,0h-.761a.193.193,0,0,1,0-.386h.761a.193.193,0,0,1,0,.386Zm-2.282,0H158.5a.193.193,0,0,1,0-.386h.761a.193.193,0,0,1,0,.386Zm-2.26,0h-.761a.2.2,0,0,1-.187-.187.187.187,0,0,1,.187-.187H157a.188.188,0,1,1,0,.375Zm-2.282,0h-.761a.187.187,0,0,1,0-.375h.761a.187.187,0,0,1,.2.187.2.2,0,0,1-.221.187Zm-2.282,0h-.761a.187.187,0,1,1,0-.375h.761a.187.187,0,0,1,0,.375Zm-2.271,0H149.4a.187.187,0,0,1,0-.375h.761a.187.187,0,1,1,0,.375Zm-2.282,0h-.8a.187.187,0,0,1-.2-.187.2.2,0,0,1,.2-.187h.761a.187.187,0,0,1,0,.375Zm-2.282,0h-.728a.193.193,0,1,1,0-.386h.761a.2.2,0,0,1,.187.187.187.187,0,0,1-.243.2Zm-2.282,0h-.761a.193.193,0,1,1,0-.386h.761a.193.193,0,1,1-.022.386Zm-2.282,0h-.761a.193.193,0,0,1,0-.386h.761a.193.193,0,1,1-.022.386Zm-2.282,0h-.761a.193.193,0,0,1,0-.386h.761a.193.193,0,1,1-.022.386Zm-2.282,0h-.761a.193.193,0,0,1,0-.386h.761a.193.193,0,1,1-.022.386Z",
    transform: "translate(13.91 15.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8686",
    "data-name": "Caminho 8686",
    d: "M169.173,152.356a.187.187,0,0,1-.187-.187v-.132H168.8a.193.193,0,1,1,0-.386h.573v.573A.188.188,0,0,1,169.173,152.356Z",
    transform: "translate(17.305 15.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8687",
    "data-name": "Caminho 8687",
    d: "M169.148,163.265a.2.2,0,0,1-.2-.2v-.739a.193.193,0,0,1,.386,0v.739A.2.2,0,0,1,169.148,163.265Zm0-2.205a.2.2,0,0,1-.2-.2v-.728a.193.193,0,1,1,.386,0v.728a.2.2,0,0,1-.187.187Zm0-2.205a.2.2,0,0,1-.187-.187v-.739a.193.193,0,1,1,.386,0v.739a.2.2,0,0,1-.21.165Zm0-2.205a.2.2,0,0,1-.187-.187v-.739a.193.193,0,1,1,.386,0v.739a.2.2,0,0,1-.21.154Zm0-2.205a.2.2,0,0,1-.187-.187v-.739a.193.193,0,0,1,.386,0v.739a.2.2,0,0,1-.21.143Z",
    transform: "translate(17.341 15.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8688",
    "data-name": "Caminho 8688",
    d: "M247.13,175.72l.6,2.988.485-.838.364.551.518-.342-.364-.54.959-.143Z",
    transform: "translate(-85.472 6.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2347",
    "data-name": "Ret\\xE2ngulo 2347",
    width: 150.477,
    height: 2.735,
    transform: "translate(190.127 86.119) rotate(-26.83)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8689",
    "data-name": "Caminho 8689",
    d: "M147.726,77.38,112,114.991h68.364l.176.176v-.176H291.609V372.369h2.856V342.7l19.384,19.462-10.144,10.177h5.568l7.355-7.388,7.355,7.388h5.568l-10.133-10.177,19.351-19.429v29.606h2.845V114.991h49.211V77.38Zm-3.749,34.865H118.285L144.55,84.679Zm2.735,0,.584-28.492,30.124,28.492Zm31.116-3.308L148.222,80.831l.684-.717h29.253ZM321.369,80.115h31.194l-31.569,30.532Zm-2.735,0-.353,28.823L287.9,80.115Zm-137.709,0H212.12l-31.58,30.532Zm33.322,32.131H182.812l32.076-31.017Zm2.735,0,.584-28.492,30.058,28.492Zm31.072-3.308L217.688,80.115h30.731Zm3.087-28.768h31.2L250.767,110.7Zm33.322,32.076H253.028l32.087-31.006Zm2.735,0,.6-28.492,29.893,28.327Zm8.2,174.912h42.463l-21.237,21.358Zm41.217,46.973H296.648l19.98-20.1Zm-39.971-50.909,19.98-20.068,19.991,20.068Zm-2.205-3.407v-38.9l19.384,19.462Zm.937-43.554h42.463l-21.215,21.314Zm-.937-7.355v-38.89l19.384,19.451Zm2.205,3.407,19.98-20.068,19.991,20.068ZM295.4,185.351h42.463l-21.237,21.3Zm1.246-3.947,19.98-20.068L336.619,181.4ZM295.4,134.442h42.463l-21.237,21.314Zm18.447,24.115-19.384,19.462V139.106ZM294.465,291.821l19.384,19.462-19.384,19.451Zm22.163,67.57L295.4,338.077h42.463Zm22.141-28.669-19.351-19.418,19.351-19.428Zm0-50.909L319.418,260.4l19.351-19.428Zm0-50.909-19.351-19.417,19.351-19.429Zm0-50.9-19.351-19.451,19.351-19.429Zm0-47.48h-44.3V114.991h44.3Zm15.922-18.282-31.271-.165,31.91-30.874Zm33.388,0H357.426l.584-28.492Zm0-3.76L358.131,80.115h29.948Z",
    transform: "translate(11.496 7.943)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8690",
    "data-name": "Caminho 8690",
    d: "M315.818,18.1a10.21,10.21,0,0,0-9.924-8.06h-1.257a10.188,10.188,0,0,0-9.924,8.005l-12.6,51.218h46.311Zm8.226,44.822L307,43.77l9.648-10.894Zm-26.618-44.26a7.465,7.465,0,0,1,7.255-5.888h1.257a7.465,7.465,0,0,1,7.255,5.932l1.874,7.641-19.561.066Zm-2.558,10.409,20.862-.066.188.728-10.651,12.03-10.641-11.92Zm-.97,3.914L303.49,43.77l-17,19.153ZM286.84,66.528l18.381-20.763L323.68,66.528Z",
    transform: "translate(28.956 1.031)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8691",
    "data-name": "Caminho 8691",
    d: "M320.584,58.845V88.23a1.985,1.985,0,0,1-1,1.731l-10.442,6.031a1.985,1.985,0,0,1-2.988-1.72V58.845a1.985,1.985,0,0,1,1.985-1.985h10.453a1.985,1.985,0,0,1,2,1.985Z",
    transform: "translate(31.423 5.837)",
    fill: "#eef6f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8692",
    "data-name": "Caminho 8692",
    d: "M300.547,58.845V112.29a2,2,0,0,1-2,2H265.626a2,2,0,0,1-1.819-2.823l20.134-44.028a22.825,22.825,0,0,1,14.092-10.508,2.007,2.007,0,0,1,2.514,1.919Z",
    transform: "translate(27.059 5.837)",
    fill: "#eef6f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8693",
    "data-name": "Caminho 8693",
    d: "M402.275,70.93,373.22,127.363l7.266-.838,24.589-50.567Z",
    transform: "translate(-72.53 -4.573)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8694",
    "data-name": "Caminho 8694",
    d: "M416.644,64.34,381.58,131.248l4.609-1.808,30.6-61.042Z",
    transform: "translate(-71.672 -5.249)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8695",
    "data-name": "Caminho 8695",
    d: "M423.815,78.23l-21.325,40,4.609-1.819,16.848-34.127Z",
    transform: "translate(-69.526 -3.823)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8696",
    "data-name": "Caminho 8696",
    d: "M325.7,49.56H301.9a28.756,28.756,0,0,0-24.72,14.068l-21.922,47.978a7.652,7.652,0,0,0,6.969,10.839h61.45A8.942,8.942,0,0,0,332.4,113.5V56.253A6.693,6.693,0,0,0,325.7,49.56Zm-24.258,63.479a2,2,0,0,1-2,2H266.557a2,2,0,0,1-1.819-2.823l20.134-44.028a22.825,22.825,0,0,1,14.092-10.508,2.007,2.007,0,0,1,2.514,1.919Zm24.4-24.06a1.985,1.985,0,0,1-1,1.731L314.4,96.742a1.985,1.985,0,0,1-2.988-1.72V59.594a1.985,1.985,0,0,1,1.985-1.985H323.85a1.985,1.985,0,0,1,2,1.985Z",
    transform: "translate(26.128 5.087)",
    fill: "#d76e4e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2348",
    "data-name": "Ret\\xE2ngulo 2348",
    width: 1.632,
    height: 62.288,
    transform: "translate(183.821 124.522)",
    fill: "#383057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2349",
    "data-name": "Ret\\xE2ngulo 2349",
    width: 1.632,
    height: 62.288,
    transform: "translate(194.054 125.702)",
    fill: "#383057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2350",
    "data-name": "Ret\\xE2ngulo 2350",
    width: 5.69,
    height: 10.42,
    transform: "translate(186.512 197.098)",
    fill: "#383057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8697",
    "data-name": "Caminho 8697",
    d: "M172.5,182.533a8.237,8.237,0,1,1,8.237-8.237,8.237,8.237,0,0,1-8.237,8.237Zm0-15.657a3.08,3.08,0,1,0,0-.055Zm0,12.129a4.7,4.7,0,1,0,0-.044Zm0-8.623a1.62,1.62,0,1,0,0-.044Z",
    transform: "translate(16.86 17.045)",
    fill: "#383057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8698",
    "data-name": "Caminho 8698",
    d: "M176.461,198.42a2.5,2.5,0,0,1-1.676-2.36v-8.49h-4.091V199.7a2.448,2.448,0,0,0,2.448,2.448,6.12,6.12,0,0,1,4.113,1.885,6.043,6.043,0,0,1,1.687,4.2,5.094,5.094,0,0,1-2.569,4.532,7.454,7.454,0,0,1-7.035,0,5.105,5.105,0,0,1-2.569-4.411,2.283,2.283,0,0,0-2.084-2.294,2.205,2.205,0,0,0-2.3,2.205,9.439,9.439,0,0,0,2.955,6.958,10.013,10.013,0,0,0,1.378,1.1,11.578,11.578,0,0,0,12.283,0,9.921,9.921,0,0,0,1.367-1.1,9.45,9.45,0,0,0,2.966-6.958,10.475,10.475,0,0,0-6.869-9.847Z",
    transform: "translate(16.667 19.253)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8699",
    "data-name": "Caminho 8699",
    d: "M174.676,132.09A18,18,0,1,1,192.66,114.1a18,18,0,0,1-17.984,17.988Zm0-35.174A17.19,17.19,0,1,0,191.855,114.1a17.19,17.19,0,0,0-17.179-17.186Z",
    transform: "translate(16.081 9.864)",
    fill: "#d76e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8700",
    "data-name": "Caminho 8700",
    d: "M184.4,113.405a10.475,10.475,0,1,0-10.475,10.475A10.475,10.475,0,0,0,184.4,113.405Z",
    transform: "translate(16.777 10.565)",
    fill: "#d76e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8701",
    "data-name": "Caminho 8701",
    d: "M95.839,205.738c10.784,10.221,31.723,5.954,22.56-1.5-.507-.4-2.282-2.657-4.852-5.866-5.348-6.726-14.114-17.642-21.766-24.809-4.995-4.653-9.516-7.718-12.316-6.88C52.362,174.423,76.631,187.545,95.839,205.738Z",
    transform: "translate(6.916 17.095)",
    fill: "#fcb295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8702",
    "data-name": "Caminho 8702",
    d: "M86.67,179.349s12.857,15.635,23.519,18.006a11.182,11.182,0,0,1,1.334.364c-5.348-6.726-14.114-17.642-21.766-24.809Z",
    transform: "translate(8.896 17.748)",
    fill: "#be7264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8703",
    "data-name": "Caminho 8703",
    d: "M172.813,343.6l-1.422,8.138h-3.848l-1.852-9Z",
    transform: "translate(-93.831 23.326)",
    fill: "#fcb295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8704",
    "data-name": "Caminho 8704",
    d: "M91.885,222.25a500.279,500.279,0,0,1-5.954,67.074c-4.2,26.055-13.055,55.364-13.055,55.364H65.928s-2.558-35.2-4.058-57.337c-1.433-21.038-7.421-61.241-7.421-61.241Z",
    transform: "translate(5.589 22.812)",
    fill: "#383057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8705",
    "data-name": "Caminho 8705",
    d: "M73.994,335.439a1.654,1.654,0,0,0,.915-2.26,4.333,4.333,0,0,0,.165-1.665c-.165-.518-11.026-1.478-11.589,0s.452,1.919.452,1.919-1.312,1.048.066,1.4S70.377,336.431,73.994,335.439Z",
    transform: "translate(6.499 33.946)",
    fill: "#292340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8706",
    "data-name": "Caminho 8706",
    d: "M78.278,220s-.64,17.466-3.506,47.1c-2.977,30.874-9.626,66.985-9.626,66.985s-2.371-37.854-3.914-54.217c-1.246-13.618-6.781-53.489-6.781-53.489Z",
    transform: "translate(5.589 22.581)",
    fill: "#292340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8707",
    "data-name": "Caminho 8707",
    d: "M71.477,337.77s16.749,0,20.024,8.545H64.178s-2.205-6.009,2.514-8.292C66.692,338.024,68.622,339.667,71.477,337.77Z",
    transform: "translate(6.535 34.669)",
    fill: "#383057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8708",
    "data-name": "Caminho 8708",
    d: "M120.839,329.411l-7.277,4.333-2.591-3.01,5.767-7.454Z",
    transform: "translate(-99.447 21.329)",
    fill: "#fcb295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8709",
    "data-name": "Caminho 8709",
    d: "M68.168,220.7s3.451,53.258-6.7,68.926c-12.25,18.866-44.006,39.122-44.006,39.122l-2.768-5.756S31.439,295.9,36.544,276.952c3.429-12.68-6.076-49.994-6.02-53.7S68.168,220.7,68.168,220.7Z",
    transform: "translate(1.508 22.636)",
    fill: "#383057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8710",
    "data-name": "Caminho 8710",
    d: "M15.053,321.67s10.828,14.015,5.954,22.053L3.74,321.461s3.473-5.59,8.314-3.154C12.054,318.307,11.657,320.535,15.053,321.67Z",
    transform: "translate(0.384 32.609)",
    fill: "#383057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8711",
    "data-name": "Caminho 8711",
    d: "M17.946,321.575a1.709,1.709,0,0,0,2.26-1.1,4.41,4.41,0,0,0,1.257-1.169c.232-.507-7.443-8.667-8.909-7.939s-.959,1.786-.959,1.786-1.72-.1-.9,1.1S14.461,319.9,17.946,321.575Z",
    transform: "translate(1.075 31.954)",
    fill: "#292340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8712",
    "data-name": "Caminho 8712",
    d: "M69.27,158.14l2.382,50.721s20.63-13.232,31.977-26.761C103.6,182.067,90.253,163.146,69.27,158.14Z",
    transform: "translate(7.11 16.232)",
    fill: "#d86e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8713",
    "data-name": "Caminho 8713",
    d: "M90.359,194.93l-6.715,5.513L69.31,158.19a31.579,31.579,0,0,1,8.678,3.694C83.909,170.473,91.186,178.1,90.359,194.93Z",
    transform: "translate(7.114 16.237)",
    fill: "#b85e43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8714",
    "data-name": "Caminho 8714",
    d: "M96.377,230.049S72.329,242.09,24.011,233.5c0,0-4.234-80.107,37.765-78.287C87.4,156.26,89.706,179.449,96.377,230.049Z",
    transform: "translate(2.452 15.929)",
    fill: "#d86e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8715",
    "data-name": "Caminho 8715",
    d: "M24.013,232.334s-2.459-44.789,13.375-65.784l2.062,20.663s-5.182,10.96-7.156,19.848c-3.65,16.22-3.2,26.144-3.2,26.144Z",
    transform: "translate(2.451 17.095)",
    fill: "#b85e43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8716",
    "data-name": "Caminho 8716",
    d: "M64.4,156.715s-2.988,5.3-12.052-.232a17.278,17.278,0,0,0,.4-9.924l9.229,2.205S61.083,152.316,64.4,156.715Z",
    transform: "translate(5.373 15.044)",
    fill: "#be7264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8717",
    "data-name": "Caminho 8717",
    d: "M55.985,130.174c-4.708,1.036-7.344,7.222-5.877,13.816s6.439,11.093,11.148,10.056,7.344-7.222,5.888-13.816S60.693,129.137,55.985,130.174Z",
    transform: "translate(5.102 13.346)",
    fill: "#fcb295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8718",
    "data-name": "Caminho 8718",
    d: "M63.429,139a41.494,41.494,0,0,1,4.19,6.285.629.629,0,0,1-.408.86,18.291,18.291,0,0,1-4.411.882C61.543,146.895,63.429,139,63.429,139Z",
    transform: "translate(6.402 14.268)",
    fill: "#fcb295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8719",
    "data-name": "Caminho 8719",
    d: "M64.631,134.68a16.748,16.748,0,0,1,1.7,3.109,7.906,7.906,0,0,1-6.274-1.191c-4.73-3.087-9.5.364-9.5.364l.584-3.981,12.493-2.812Z",
    transform: "translate(5.189 13.361)",
    fill: "#be7264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8720",
    "data-name": "Caminho 8720",
    d: "M49.862,129.31a2.525,2.525,0,0,0-1.577-.353c-1.268.1-1.268-1.886,0-1.985a4.289,4.289,0,0,1,2.205.463,4.587,4.587,0,0,1,1.522-2.514c.992-.794,2.4.606,1.411,1.4a3.186,3.186,0,0,0-.6.628,9.162,9.162,0,0,1,2.779-1.048c2.657-.507,11.17.276,14.467,2.746,3.639,2.724,1.3,6.693-.651,7.818-2.558,1.467-6.252,1.014-8.534-.2s-5.436-1.378-6.186,1.048a3.087,3.087,0,0,1-2.878,2.36c-1.367,2.768-.221,5.6.651,9.924-3.363.088-5.69-6.495-6.406-10.629C45.539,135.518,47.315,131.891,49.862,129.31Z",
    transform: "translate(4.719 12.798)",
    fill: "#383057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8721",
    "data-name": "Caminho 8721",
    d: "M52.575,140.6s-1.8-1.941-3.165-.386.739,6.495,3.087,4.852S52.575,140.6,52.575,140.6Z",
    transform: "translate(5.027 14.33)",
    fill: "#fcb295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8722",
    "data-name": "Caminho 8722",
    d: "M66.5,128.5a2.459,2.459,0,0,1,1.874,1.7,3.892,3.892,0,0,1-.419,3.01.5.5,0,0,1-.86-.5c.706-1.235.617-2.779-.86-3.253C65.626,129.263,65.879,128.3,66.5,128.5Z",
    transform: "translate(6.763 13.187)",
    fill: "#292340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8723",
    "data-name": "Caminho 8723",
    d: "M51.724,136.07c.783-.2.97-1.29,1.422-1.852a3.827,3.827,0,0,1,1.433-1.1c.573-.265,1.1.584.507.86a3.573,3.573,0,0,0-1.731,1.863,2.04,2.04,0,0,1-1.378,1.191C51.36,137.172,51.1,136.213,51.724,136.07Z",
    transform: "translate(5.272 13.658)",
    fill: "#292340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8724",
    "data-name": "Caminho 8724",
    d: "M193.941,228.31l-24.931,5.16,23.861,3.01Z",
    transform: "translate(-93.49 11.581)",
    fill: "#383057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8725",
    "data-name": "Caminho 8725",
    d: "M169.021,232.99l-.121,3.562,24,3.661L192.882,236Z",
    transform: "translate(-93.501 12.061)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8726",
    "data-name": "Caminho 8726",
    d: "M242.121,232.9l-51.471,3.109.022,4.212,51.449-3.44Z",
    transform: "translate(-91.269 12.052)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8727",
    "data-name": "Caminho 8727",
    d: "M89.652,195.651a2.04,2.04,0,0,1,1.9-1.764l47.336-2.867a2.04,2.04,0,0,1,1.1.265l2.668,1.246-1.334,2.007-.32-.121-1.764,29.661-48.858,4.411-2.679-.342Z",
    transform: "translate(9.002 19.607)",
    fill: "#c2beb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8728",
    "data-name": "Caminho 8728",
    d: "M141.6,225.24,90.13,228.371l1.886-31.58a2.029,2.029,0,0,1,1.9-1.764l47.325-2.867a2.04,2.04,0,0,1,2.139,2.3Z",
    transform: "translate(9.251 19.724)",
    fill: "#e0dcd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8729",
    "data-name": "Caminho 8729",
    d: "M124.111,226.279c.11-.485.584-1.323,1.3-1.169a.936.936,0,0,1,.243.1,2.437,2.437,0,0,1,0-1.014c.2-.717.915-1.742,1.886-1.1a2.8,2.8,0,0,1,.9.992,1.985,1.985,0,0,1,1.367-1.455c1.18-.408,1.72.342,2.007,1.213.221-.86.761-2.106,1.874-1.444a4.554,4.554,0,0,1,1.356,1.764,11.026,11.026,0,0,1,1.014,2.525.3.3,0,0,1,0,.1.32.32,0,0,1,.066.375c-.375.893-1.511,1.819-2.58.97a4.817,4.817,0,0,1-.75-.75c.055.816-.154,1.533-1.048,1.687a2.437,2.437,0,0,1-2.249-1.356v.055c-.265.364-.606.838-1.191.816a1.709,1.709,0,0,1-1.1-.684.287.287,0,0,1-.154.232,1.919,1.919,0,0,1-2.944-1.852Z",
    transform: "translate(12.737 22.808)",
    fill: "#fcb295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8730",
    "data-name": "Caminho 8730",
    d: "M83.2,227.5c.959.992,1.919.254,3.22.309,1.6.066,7.421,2.966,8.755,1.764,1.841-1.654-4.168-1.93-3.076-2.922.4-.342,6.925,2.382,6.373.265-.243-.915-5.171-2.933-3.7-3.308,1.72.287,6.12,2.382,6.506.9.187-.695-2.624-2.415-3.672-2.712-3.639-1.1-2.679-2.062.849-1.268,1.819.408,2.668-.507,1.1-1.61-3.308-2.3-9.009-.629-12.515.882C85.54,220.425,81.074,225.288,83.2,227.5Z",
    transform: "translate(8.482 22.355)",
    fill: "#fcb295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8731",
    "data-name": "Caminho 8731",
    d: "M84.584,222.56c-.309.959,1,1.433,1.522.75a5.171,5.171,0,0,0,2.205-2.3c.254-.6.364-1.246.662-1.819a5.579,5.579,0,0,1,2-1.9c.474-.342.695-1.2,0-1.511C87.936,214.379,85.246,220.52,84.584,222.56Z",
    transform: "translate(8.677 22.127)",
    fill: "#fcb295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8732",
    "data-name": "Caminho 8732",
    d: "M53.454,161.47s13.463,10.177,12.052,24.611-8.336,25.769,2.867,32.826L41.59,208.487l2.966-24.192s.507-8.821,1.908-12.383S53.454,161.47,53.454,161.47Z",
    transform: "translate(4.269 16.574)",
    fill: "#b85e43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8733",
    "data-name": "Caminho 8733",
    d: "M43.256,219.62c9.394,7.3,26.342,14.775,46.311,13.871l1.169-6.373s-6.947-3.528-14.467-7.718c-7.972-4.411-16.606-9.637-18.359-12.129-1.522-2.205.695-14.775.97-25.438.176-6.836-.43-12.89-3.308-14.908C33.619,151.476,29.34,208.8,43.256,219.62Z",
    transform: "translate(3.618 16.864)",
    fill: "#fcb295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8734",
    "data-name": "Caminho 8734",
    d: "M54.869,209.86c5.006,4.411,15.084,7.156,19.848,8.082-7.972-4.411-16.606-9.637-18.359-12.129-1.522-2.205.695-14.775.97-25.438l-4.741-2S47.062,202.947,54.869,209.86Z",
    transform: "translate(5.203 18.31)",
    fill: "#be7264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8735",
    "data-name": "Caminho 8735",
    d: "M45.934,157.766c5.149-1,19.484,10.64,16.87,30.94,0,0-20.333,5.293-29.474,1.213C33.331,189.919,30.387,160.809,45.934,157.766Z",
    transform: "translate(3.398 16.188)",
    fill: "#d86e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8736",
    "data-name": "Caminho 8736",
    d: "M166.323,235.648l-1.1-.11c.408-4.168,2.646-25.1,6.131-26.871a1.323,1.323,0,0,1,1.312,0c3.87,2.205,9.064,20.211,9.637,22.251l-1.1.309c-1.544-5.436-6.175-19.848-9.13-21.612a.254.254,0,0,0-.265,0C169.586,210.805,167.26,226.209,166.323,235.648Z",
    transform: "translate(16.958 21.4)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8737",
    "data-name": "Caminho 8737",
    d: "M237.685,258.483l-5.822-32.351A7.608,7.608,0,0,0,223.042,220l-93.879,16.881a7.608,7.608,0,0,0-6.142,8.821l5.822,32.352a7.608,7.608,0,0,0,8.821,6.142L231.51,267.3a7.608,7.608,0,0,0,6.175-8.821Z",
    transform: "translate(12.615 22.569)",
    fill: "#292340",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8738",
    "data-name": "Caminho 8738",
    d: "M135.919,287.728l93.846-16.881a7.608,7.608,0,0,0,6.142-8.821l-5.767-32.362a7.6,7.6,0,0,0-8.821-6.142L127.473,240.4a7.608,7.608,0,0,0-6.142,8.821l5.822,32.352A7.608,7.608,0,0,0,135.919,287.728Z",
    transform: "translate(12.441 22.93)",
    fill: "#ffc88b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2351",
    "data-name": "Ret\\xE2ngulo 2351",
    width: 54.757,
    height: 10.034,
    transform: "translate(181.75 262.667) rotate(-10.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2352",
    "data-name": "Ret\\xE2ngulo 2352",
    width: 10.244,
    height: 1.533,
    transform: "translate(184.68 278.914) rotate(-10.2)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2353",
    "data-name": "Ret\\xE2ngulo 2353",
    width: 40.853,
    height: 1.533,
    transform: "translate(198.349 276.452) rotate(-10.2)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2354",
    "data-name": "Ret\\xE2ngulo 2354",
    width: 27.026,
    height: 1.533,
    transform: "translate(185.327 282.474) rotate(-10.2)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2355",
    "data-name": "Ret\\xE2ngulo 2355",
    width: 10.244,
    height: 1.533,
    transform: "translate(214.044 277.31) rotate(-10.2)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2356",
    "data-name": "Ret\\xE2ngulo 2356",
    width: 12.758,
    height: 1.533,
    transform: "translate(226.648 275.035) rotate(-10.2)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2357",
    "data-name": "Ret\\xE2ngulo 2357",
    width: 32.318,
    height: 1.533,
    transform: "translate(185.953 286.035) rotate(-10.2)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2358",
    "data-name": "Ret\\xE2ngulo 2358",
    width: 19.517,
    height: 1.533,
    transform: "translate(220.644 279.801) rotate(-10.2)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2359",
    "data-name": "Ret\\xE2ngulo 2359",
    width: 25.548,
    height: 1.533,
    transform: "translate(215.359 284.507) rotate(-10.2)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2360",
    "data-name": "Ret\\xE2ngulo 2360",
    width: 6.318,
    height: 1.533,
    transform: "translate(186.603 289.597) rotate(-10.2)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2361",
    "data-name": "Ret\\xE2ngulo 2361",
    width: 17.973,
    height: 1.533,
    transform: "translate(195.112 288.057) rotate(-10.2)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2362",
    "data-name": "Ret\\xE2ngulo 2362",
    width: 10.244,
    height: 1.533,
    transform: "translate(187.228 293.165) rotate(-10.2)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2363",
    "data-name": "Ret\\xE2ngulo 2363",
    width: 40.853,
    height: 1.533,
    transform: "translate(200.919 290.691) rotate(-10.2)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8739",
    "data-name": "Caminho 8739",
    d: "M164.375,241.348l5.061,28.106a2.47,2.47,0,0,1-1.985,2.856l-30.312,5.447a2.459,2.459,0,0,1-2.856-1.985l-5.05-28.1a2.47,2.47,0,0,1,1.985-2.867l30.3-5.447a2.459,2.459,0,0,1,2.856,1.985Z",
    transform: "translate(13.261 24.565)",
    fill: "#d86e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8740",
    "data-name": "Caminho 8740",
    d: "M166.525,254.42l2.5,13.893a2.47,2.47,0,0,1-1.985,2.856l-30.312,5.447a2.459,2.459,0,0,1-2.856-1.985l-.706-3.925,4.223-6.814a1.169,1.169,0,0,1,1.687-.342l8.259,5.954a1.191,1.191,0,0,0,1.687-.32l11.523-18.194a1.191,1.191,0,0,1,1.775-.265Z",
    transform: "translate(13.669 25.706)",
    fill: "#5b67b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8741",
    "data-name": "Caminho 8741",
    d: "M144.5,250.33a4.311,4.311,0,1,0-3.484,5.006A4.311,4.311,0,0,0,144.5,250.33Z",
    transform: "translate(13.953 25.33)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignGroupExcluded);
export default __webpack_public_path__ + "static/media/Campaign Group Excluded.cfdeb0b5.svg";
export { ForwardRef as ReactComponent };